import React, { useState } from "react";
import { useGetPinnedMessages } from "../../hooks/queries/useGetPinnedMessages";
import { usePinMessage } from "../../hooks/mutations/usePinMessage";
import { PinnedMessagePreview } from "./PinnedMessagePreview";
import { PinnedMessageList } from "./PinnedMessageList";
import styles from "./PinnedMessages.module.scss";

interface PinnedMessagesProps {
  roomId: string;
  onScrollToMessage: (messageId: string) => void;
}

export const PinnedMessages: React.FC<PinnedMessagesProps> = ({ roomId, onScrollToMessage }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { data: pinnedMessages } = useGetPinnedMessages(roomId);
  const { mutate: unpinMessage } = usePinMessage(roomId);

  const messages = pinnedMessages?.data?.Data || pinnedMessages?.Data || [];

  if (!messages || messages.length === 0) {
    return null;
  }

  const handleUnpin = async (messageId: string) => {
    await unpinMessage({ messageId, pin: false });
    setIsExpanded(false);
  };

  return (
    <div className={`${styles.container} ${isExpanded ? styles.expanded : ""}`}>
      {!isExpanded ? (
        <PinnedMessagePreview
          message={messages[0]}
          totalCount={messages.length}
          onExpand={() => setIsExpanded(true)}
          onUnpin={handleUnpin}
          onScrollTo={onScrollToMessage}
        />
      ) : (
        <PinnedMessageList
          messages={messages}
          onCollapse={() => setIsExpanded(false)}
          onUnpin={handleUnpin}
          onScrollTo={onScrollToMessage}
        />
      )}
    </div>
  );
};
